export function allowsLocalDemo(development: boolean, enabled: string | undefined, hostname: string) {
  return development && enabled === "true" && ["localhost", "127.0.0.1", "::1", "[::1]"].includes(hostname);
}
